/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Culture_LabelInputs */

const en_candidate_profile_culture_label = /** @type {(inputs: Candidate_Profile_Culture_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desired Company Culture & Values`)
};

const de_candidate_profile_culture_label = /** @type {(inputs: Candidate_Profile_Culture_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewünschte Unternehmenskultur & Werte`)
};

/**
* | output |
* | --- |
* | "Desired Company Culture & Values" |
*
* @param {Candidate_Profile_Culture_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_culture_label = /** @type {((inputs?: Candidate_Profile_Culture_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Culture_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_culture_label(inputs)
	return en_candidate_profile_culture_label(inputs)
});